import { useMemo } from 'react';
import { clubEvents } from '../../../mocks/events';

const MONTH_IMAGES: Record<number, { image: string; name: string }> = {
  1:  { name: 'JAN', image: 'https://public.readdy.ai/ai/img_res/148c7be5d580ccd0f495d3bb4c473c70.jpg' },
  2:  { name: 'FEB', image: 'https://readdy.ai/api/search-image?query=chinese%20new%20year%20business%20celebration%20dinner%2C%20asian%20professionals%20gathering%2C%20festive%20red%20decorations%2C%20elegant%20banquet%20hall%2C%20traditional%20lunar%20new%20year%20corporate%20event%2C%20warm%20lighting&width=400&height=300&seq=cal-feb-ymc&orientation=landscape' },
  3:  { name: 'MAR', image: 'https://readdy.ai/api/search-image?query=large%20group%20of%20business%20professionals%20hiking%20together%20on%20scenic%20mountain%20trail%2C%20national%20hiking%20event%2C%20spring%20weather%2C%20team%20bonding%20outdoor%20activity%2C%20beautiful%20nature%20landscape&width=400&height=300&seq=cal-mar-ymc&orientation=landscape' },
  4:  { name: 'APR', image: 'https://readdy.ai/api/search-image?query=professional%20golf%20tournament%20on%20beautiful%20green%20course%2C%20asian%20business%20executives%20playing%20golf%2C%20sunny%20day%2C%20corporate%20golf%20event%2C%20elegant%20country%20club%20setting&width=400&height=300&seq=cal-apr-ymc&orientation=landscape' },
  5:  { name: 'MAY', image: 'https://readdy.ai/api/search-image?query=corporate%20blood%20donation%20event%2C%20asian%20professionals%20volunteering%2C%20medical%20staff%2C%20community%20service%20activity%2C%20bright%20clean%20medical%20setting%2C%20charitable%20corporate%20event&width=400&height=300&seq=cal-may-ymc&orientation=landscape' },
  6:  { name: 'JUN', image: 'https://readdy.ai/api/search-image?query=asian%20business%20delegation%20visiting%20modern%20factory%2C%20international%20business%20trip%2C%20professional%20group%20tour%2C%20corporate%20exchange%20program%2C%20modern%20industrial%20facility&width=400&height=300&seq=cal-jun-ymc&orientation=landscape' },
  7:  { name: 'JUL', image: 'https://readdy.ai/api/search-image?query=group%20of%20business%20professionals%20deep%20sea%20fishing%20on%20boat%2C%20ocean%20fishing%20trip%2C%20summer%20activity%2C%20team%20building%20on%20water%2C%20beautiful%20coastal%20scenery%2C%20sunny%20day&width=400&height=300&seq=cal-jul-ymc&orientation=landscape' },
  8:  { name: 'AUG', image: 'https://readdy.ai/api/search-image?query=intimate%20evening%20business%20networking%20event%2C%20asian%20professionals%20in%20elegant%20private%20dining%20room%2C%20sophisticated%20atmosphere%2C%20candlelit%20discussion%2C%20executive%20gathering&width=400&height=300&seq=cal-aug-ymc&orientation=landscape' },
  9:  { name: 'SEP', image: 'https://readdy.ai/api/search-image?query=large%20corporate%20annual%20conference%2C%20asian%20business%20professionals%20in%20grand%20ballroom%2C%20national%20business%20convention%2C%20professional%20stage%20presentation%2C%20elegant%20conference%20setting&width=400&height=300&seq=cal-sep-ymc&orientation=landscape' },
  10: { name: 'OCT', image: 'https://readdy.ai/api/search-image?query=business%20delegation%20visiting%20startup%20incubator%2C%20asian%20entrepreneurs%20touring%20modern%20tech%20office%2C%20innovation%20center%20visit%2C%20professional%20business%20exchange&width=400&height=300&seq=cal-oct-ymc&orientation=landscape' },
  11: { name: 'NOV', image: 'https://readdy.ai/api/search-image?query=leadership%20training%20workshop%2C%20asian%20business%20professionals%20in%20team%20building%20activities%2C%20corporate%20retreat%2C%20mentorship%20program%2C%20outdoor%20training%20camp&width=400&height=300&seq=cal-nov-ymc&orientation=landscape' },
  12: { name: 'DEC', image: 'https://readdy.ai/api/search-image?query=elegant%20year%20end%20corporate%20gala%20dinner%2C%20asian%20business%20executives%20at%20formal%20celebration%2C%20award%20ceremony%2C%20festive%20decorations%2C%20grand%20ballroom%20event&width=400&height=300&seq=cal-dec-ymc&orientation=landscape' },
};

export default function Calendar() {
  const calendarMonths = useMemo(() => {
    return Array.from({ length: 12 }, (_, i) => {
      const month = i + 1;
      const monthEvents = clubEvents
        .filter((e) => e.month === month && e.type !== '理監事會議')
        .slice(0, 2)
        .map((e) => ({ date: e.date.split('（')[0].split('(')[0], title: e.title }));
      return {
        month: String(month).padStart(2, '0'),
        ...MONTH_IMAGES[month],
        activities: monthEvents,
      };
    });
  }, []);

  return (
    <section id="calendar" className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 sm:gap-0 mb-10 sm:mb-16">
          <div className="text-center sm:text-left">
            <p className="text-xs sm:text-sm font-light text-orange-600 mb-2 sm:mb-3 tracking-wider uppercase">2026 Annual Calendar</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-purple-900">
              年度活動計畫
            </h2>
          </div>
          <a
            href="/annual-plan"
            className="inline-flex items-center gap-2 text-sm font-medium text-orange-600 hover:text-orange-800 transition-colors whitespace-nowrap cursor-pointer self-center sm:self-auto"
          >
            查看完整年度計畫
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>

        {/* Calendar Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6">
          {calendarMonths.map((event) => (
            <div
              key={event.month}
              className="bg-white rounded-xl sm:rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group cursor-pointer border border-gray-100"
            >
              {/* Image Section */}
              <div className="relative h-24 sm:h-32 lg:h-36 overflow-hidden">
                <img
                  src={event.image}
                  alt={`${event.name} 活動`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                <div className="absolute bottom-2 sm:bottom-3 left-3 sm:left-4">
                  <div className="text-2xl sm:text-3xl font-black text-white leading-none">
                    {event.month}
                  </div>
                  <div className="text-[10px] sm:text-xs font-light text-white/80 tracking-wider">
                    {event.name}
                  </div>
                </div>
              </div>

              {/* Content Section */}
              <div className="p-3 sm:p-4 lg:p-5">
                <div className="space-y-1.5 sm:space-y-2">
                  {event.activities.map((activity, idx) => (
                    <div key={idx} className="flex items-start gap-1.5 sm:gap-2">
                      <span className="text-orange-600 font-medium text-xs sm:text-sm shrink-0">{activity.date}</span>
                      <span className="text-gray-700 text-xs sm:text-sm line-clamp-1">{activity.title}</span>
                    </div>
                  ))}
                </div>

                <div className="mt-3 sm:mt-4 pt-2 sm:pt-3 border-t border-gray-100 opacity-0 group-hover:opacity-100 transition-opacity duration-300 hidden sm:block">
                  <a href="/annual-plan" className="text-xs sm:text-sm text-purple-900 font-medium flex items-center gap-2 whitespace-nowrap">
                    查看詳情
                    <i className="ri-arrow-right-line w-3 sm:w-4 h-3 sm:h-4 flex items-center justify-center"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
